<div class="switch-container">
  <span
    class="type-switch"
    [ngClass]="{ active: type === 'Topic Cluster' }"
    (click)="typeChange.emit('Topic Cluster')">
    Topic Clusters
  </span>
  <span
    class="type-switch"
    [ngClass]="{ active: type === 'Topic' }"
    (click)="typeChange.emit('Topic')">
    Topics
  </span>
</div>
